import { render, staticRenderFns } from "./rewardAndPunishmentNotificationModal.vue?vue&type=template&id=3173e2aa"
import script from "./rewardAndPunishmentNotificationModal.vue?vue&type=script&lang=js"
export * from "./rewardAndPunishmentNotificationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports